export enum ElevationProfileReportFormat {
  PDF = 'pdf',
  SHP = 'shp',
  DXF = 'dxf',
}
